import { Introduction, SpaceBetween, spacing, styled, useTranslation } from '@lessonup/ui-components';
import React from 'react';
import {
  FullPageBodySection,
  FullPageBodySectionTransparent,
} from '../../../components/FullPageFlow/FullPageBodySection';
import { AiToolboxGenerator } from '../AiToolbox.types';
import { i18nextNamespaceAiTools } from '../AiToolbox.utils';
import { FeedbackButton } from '../FeedbackButton';
import { useAiToolboxContext } from '../context/AiToolboxContext';
import { FullWidth } from './DefaultToolWrapper';

interface ToolFormProps {
  generator: AiToolboxGenerator;
  children: React.ReactNode;
}

export const AiToolboxFormWrapper: React.FC<ToolFormProps> = ({ children, generator }) => {
  const { t } = useTranslation(i18nextNamespaceAiTools);
  const { showInline } = useAiToolboxContext();

  if (showInline) {
    return <>{children}</>;
  }

  return (
    <Wrapper>
      <FullPageBodySectionTransparent>
        <Introduction
          alignment="center"
          size="M"
          headline={t(generator.labelKey)}
          bodyText={t(generator.descriptionKey)}
        />
        <StyledFeedbackButtonWrapper>
          <FeedbackButton />
        </StyledFeedbackButtonWrapper>
      </FullPageBodySectionTransparent>
      <FullPageBodySection>
        <FullWidth>
          <SpaceBetween direction="y" spacing={spacing.size16}>
            {children}
          </SpaceBetween>
        </FullWidth>
      </FullPageBodySection>
    </Wrapper>
  );
};

const StyledFeedbackButtonWrapper = styled.div`
  margin-top: ${spacing.size8};
`;

const Wrapper = styled.div`
  @media print {
    display: none;
  }
`;
